import { Injectable } from '@angular/core';
import { Endpoint } from '../configuration/endpoints';

@Injectable({
  providedIn: 'root',
})
export class InterceptorConfigService {
  private readonly excludedUrls: string[] = [
    '/customer/refresh-token',
    '/assets/feature-flags.manifest.json',
    '/tokenize',
    '/authorize',
    'datadoghq',
    'https://www.cloudflare.com/',
    'https://api.ipify.org?format=json',
  ];

  private readonly excludedPatterns: RegExp[] = [/\/api\/public\/.*/];

  isUrlExcluded(url: string): boolean {
    return (
      this.excludedUrls.some((excludedUrl) => url.includes(excludedUrl)) ||
      this.excludedPatterns.some((pattern) => pattern.test(url)) ||
      Boolean(Endpoint.WITHOUT_AUTHORIZATION().find((path) => url.includes(path)))
    );
  }
}
